







































import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Emit } from "vue-property-decorator";

import i18n from '@/plugins/i18n';
import Country from '@/models/Country';

@Component
export default class NavBar extends Vue {
    @Prop() public menu!: {display?: boolean};

    public currentLang: string = 'fr';
    public availableCountries: Country[] = [
        new Country('fr', 'France'),
        new Country('gb', 'English'),
    ];

    @Emit("menu-changed") public emitDisplayMenuEvent(menu: {display?: boolean}) {}

    public toggleMenu() {
        this.menu.display = !this.menu.display;
        this.emitDisplayMenuEvent(this.menu);
    }

    public changeLocale(locale: string): void {
        i18n.locale = locale;
        this.currentLang = locale;
    }
}
